export default __webpack_public_path__ + "static/Smart-ID-038c5ba29281adcae395701a34d2c0a2.webp";